import angular from "angular";
import cmsAuthService from "../../../../cmsCore/Auth/CMSAuthService";

export default angular.module('cms.ckeditor.config', [cmsAuthService])
    .factory('CKEditorConfig', function (CMSAuthService) {

        this.options = {
            toolbar: [
                {name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat']},
                {name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']},
                {name: 'insert', items: ['HorizontalRule']},
                {name: 'links', items: ['Link','Unlink']},
                '/',
                {name: 'styles', items: ['Font', 'FontSize']},
                {name: 'colors', items: ['TextColor', 'BGColor']},
            ],
            skin: 'moono-lisa',
            language: CMSAuthService.getUser().language || 'pl',
            extraPlugins: 'link,justify,font,colorbutton,divarea,sharedspace,cmsplaceholder',
            removePlugins: 'sourcearea,save,elementspath,placeholder',
            removeButtons: '',
            entities: false,
            title: false,
            basicEntities: true,
            entities_additional: '',
            resize_enabled: false,
            pasteFromWordRemoveStyles: true,
            pasteFromWordRemoveFontStyles: true,
            enterMode: CKEDITOR.ENTER_P,
            fillEmptyBlocks: true,
            format_tags: 'p;h1;h2;h3',
            fontSize_defaultLabel: 'Auto'
        };

        return {
            getOptions: () => angular.copy(this.options)
        };

    }).name;



// WEBPACK FOOTER //
// ./src/cmsCore/RichTextEditor/Editors/CKEditor/CKEditorOptions.js